import React, { useEffect } from "react";
import Card from "components/card";
import { Form, Input, Select } from 'antd';
import FormItem from "components/fields/FormItem";
import { connect } from "react-redux";
import { 
	getAccessGroupDetails, doAccessGroupCreate, doAccessGroupUpdate 
} from "../../../../redux/accessgroup/accessGroupState";
import { useForm } from 'antd/lib/form/Form';
import { requiredField } from '../../../../utils/crudSagaHelper';
import CrudButtons from "components/button/crudbuttons";
import { getAccessGroupLevelName } from "../../../../utils/index";

const { TextArea } = Input;

const AccessGroupForm = ({getRecord, doCreate, doUpdate, recordData, requesting, ...props}) => {
	
  	const { recordId, mode } = props;  	
  	const [form] = useForm();
  	useEffect(() => {
        getRecord(recordId);
	}, [getRecord, recordId]);
	
	useEffect(() => {
		if(recordData){			
			const { ...rest } = recordData;
	        const initialValues = {
	            ...rest,
	        };
	        
	        form.setFieldsValue(initialValues);
        }
    }, [recordData, form]);
    
  	const onSubmit = (values) => {	
    	try {							
			recordData.acg_id > 0 ? doUpdate(values): doCreate(values); 
    	} catch (error) {
      		console.error('Save failed:', error);
    	}
  	};
  
  	return (
    	<Card extra={"w-full h-full p-4"}>
		  	<Form form={form} className="p-4 bg-white rounded-md dark:bg-intsamis-900"
		  		layout="vertical"
		  		onFinish={onSubmit}
	        >   
	        	<FormItem
			        name="acg_id"
			        hidden
			    >
			        <Input type="hidden"/>
			    </FormItem>
        		<div className="grid grid-cols-3 gap-4">
					<FormItem className="font-medium mb-2"
		            	name="acg_name"
		                label="Group Name"
		                rules={[requiredField()]}
		            >
		            	{mode === 'edit' ?
		            	<Input id="acg_name"
		            		maxLength={20}
		            	/>
		            	: <label className="ps-3 dark:text-white">{recordData?.acg_name}</label>
		            	}	                
	            	</FormItem>
        			<FormItem className="font-medium mb-2"
		            	name="acg_level"
		                label="Access Level"
		                rules={[requiredField()]}
		            >
		            	{mode === 'edit' ?
		            	<Select id="acg_level"
		            		showSearch
		            		allowClear={true}
		            		style={{
						        width: 250,
						      }}
						    options={recordData?.accessGroupsLevelList}
		            	/>
		            	: <label className="ps-3 dark:text-white">{getAccessGroupLevelName(recordData?.acg_level)}</label>
		            	}	                
	            	</FormItem>  
					
					<FormItem className="font-medium mb-2"
		            	name="acg_status_id"
		                label="Status"
		                rules={[requiredField()]}
		            >
		            	{mode === 'edit' ?
		            	<Select id="acg_status_id"
		            		style={{
						        width: 250,
						      }}
						    options={recordData?.getStatusList}
						    filterOption={(input, option) =>
						      (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
						    }
		            	/>
		            	: <label className="ps-3 dark:text-white">{getAccessGroupLevelName(recordData?.acg_level)}</label>
		            	}	                
	            	</FormItem> 

					<FormItem className="font-medium  mb-2 col-span-2"
		            	name="acg_description"
		                label="Description"
		                initialValue={recordData?.acg_description}
		            >
		            	{mode === 'edit' ?
		            	<TextArea className="py-2"
		            		rows={2}
		            		maxLength={500}
		            	/>
		                : <label className="ps-3 dark:text-white">{recordData?.acg_description}</label>
		                }
	            	</FormItem> 
					
				</div>
	 			<CrudButtons baseRoute="/console/access-groups" mode={mode} recordId={recordId} />			 			
	 		</Form>	 	
	 	</Card>
  	);
};

const mapStateToProps = (state) => ({
  	recordData: state.accessGroup.accessGroupDetails?.data,
  	requesting: state.accessGroup.accessGroupDetails?.requesting,
});

const mapDispatchToProps = (dispatch) => ({
	getRecord: (id) => dispatch(getAccessGroupDetails(id)),
  	doCreate: (data) => dispatch(doAccessGroupCreate(data)),
  	doUpdate: (data) => dispatch(doAccessGroupUpdate(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AccessGroupForm);
